import React from 'react';
import { EmptyState, Skeleton } from '@onward-delivery/design';
import { RESPONSE_TYPES } from '@/components/Account/Surveys/constants';
import LabeledValues from '../../components/LabeledValues';
import NumberedSections from '../../components/NumberedSections';
import { useShipperSurveys } from './hooks';

const questionRows = (question) => [
    { label: 'Question', value: question.question },
    { label: 'Question Type', value: RESPONSE_TYPES[question.response_type] || question.response_type },
];

/**
 * The Surveys tab of a shipper's profile: the shipper's enabled questions for each survey type.
 * Read only.
 * @param {{ partnership: Object }} props
 */
const SurveysPage = ({ partnership }) => {
    const { sections, loading, error } = useShipperSurveys(partnership.shipper_id);

    if (loading) return <Skeleton className="mt-6 h-40 w-full" />;
    if (error) {
        return <EmptyState className="py-16" title="Couldn't load surveys" description="Please try again later." />;
    }

    return (
        <NumberedSections
            sections={sections}
            getItemKey={(question) => question.survey_id}
            renderItem={(question) => <LabeledValues rows={questionRows(question)} />}
        />
    );
};

export default SurveysPage;
